import { useMemo } from 'react';
import { useSafes } from 'store';
import { IClaimMultiSignWallet, IMultiSignWallet } from 'types';

export const isNewSubAccountError = (safe: IClaimMultiSignWallet | IMultiSignWallet) => {
  const { safes } = useSafes();
  const subaccounts = useMemo(() => {
    return safes.filter((item) => item.parrentId === safe._id);
  }, [safe]);

  if (safe.owners.length === 1) {
    return 'Vaults with a single owner don’t support sub-accounts';
  }

  if (safe.owners.length === 2 && subaccounts.length === 1) {
    return `Vaults with ${safe.owners.length} owners support only ${
      subaccounts.length
    } sub-account${subaccounts.length === 1 ? '' : 's'}`;
  }

  if (subaccounts.length >= 5) {
    return 'Vaults with 3 and more owners support only 5 sub-accounts';
  }

  return '';
};
